import { MAX_NAME_LENGTH } from '@/constants/Common'
import moment from 'moment'
import * as Yup from 'yup'
import { createLocationValidationSchema } from './CommonValidationSchema'

export const createSignUpStep1ValidationSchema = (t: any, requirePhoneNumberOnSignup = false) => {
  const locationValidationSchema = createLocationValidationSchema(t)
  // An age-verified signup (the form's `context.ageVerified`, see sign-up.tsx) has its name and
  // birthdate locked to the pre-created account's stored values, which the server forces anyway. The
  // format and under-13 rules are skipped for it so a locked value can never strand the form.
  const nameFormat = <S extends Yup.StringSchema<any, any, any, any>>(schema: S): S =>
    schema
      .matches(/^[A-Za-z ]+$/, t('constant.nameNoSpecial'))
      .matches(/^(?!\s+$)/, t('constant.nameNoWhitespace'))
      .max(MAX_NAME_LENGTH, t('constant.nameMaxLength'))
  return Yup.object().shape({
    firstName: Yup.string()
      .required(t('constant.fullNameRequired'))
      .when('$ageVerified', { is: true, otherwise: nameFormat }),
    lastName: Yup.string()
      .required(t('constant.fullNameRequired'))
      .when('$ageVerified', { is: true, otherwise: nameFormat }),
    birthDate: Yup.date()
      .typeError(t('constant.typeDate'))
      .required(t('constant.birthDateRequired'))
      .test('birthDate', t('constant.birthDateMin'), function (value) {
        if (this.options.context?.ageVerified) return true
        return moment().diff(moment(value), 'years') >= 13
      }),
    email: Yup.string()
      .required(t('constant.emailRequired'))
      .email(t('constant.emailInvalid'))
      .matches(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-\\.]+$/, t('constant.emailInvalid')),
    confirmEmail: Yup.string()
      .required(t('constant.emailRequired'))
      .email(t('constant.emailInvalid'))
      .oneOf([Yup.ref('email'), ''], t('constant.emailConfirm')),
    address: locationValidationSchema,
    phoneData: Yup.object().shape({
      phoneNumber: requirePhoneNumberOnSignup
        ? Yup.string().required(t('constant.phoneRequired', 'Phone number is required.'))
        : Yup.string().optional(),
    }),
    phoneOptIn: Yup.boolean().when('phoneData.phoneNumber', {
      is: (phoneNumber: string) => phoneNumber && phoneNumber.length > 0,
      then: (schema) => schema.oneOf([true], t('constant.phoneOptInRequired', 'Please check this box to continue.')),
      otherwise: (schema) => schema.optional(),
    }),
    termsOfService: Yup.boolean().oneOf([true], t('auth.acceptTerms')),
  })
}
